import { FunctionalComponent, h } from '@stencil/core';
import { href } from 'stencil-router-v2';
import get from 'lodash/get'
interface AppLink {
    data,
    className,
    hyphenGroup?,
}


export const AppLink: FunctionalComponent<AppLink> = ({ data, className, hyphenGroup }, children) => {

    if (!data) return children;
    const { Alt, Icon, Label, NewTab, URL, HideLabel} = data;
    const slug = get(data, 'page.data.attributes.Slug');
    const icon = Icon ? (<span aria-hidden="true" class={`${className.includes('uk-icon-button') ? 'uk-icon-button' : 'uk-margin-small-right uk-icon'}`} uk-icon={Icon}></span>) : '';
    const link = URL && (URL.startsWith('http') || URL.startsWith('mailto:') || URL.startsWith('tel:') || URL.startsWith('#')) ? { href: URL } : href(URL || '/' + slug)
    const scroll = URL && URL.startsWith('#') ? { 'uk-scroll': true } : {}
    const cleanClass = URL && (URL.startsWith('http') || URL.startsWith('mailto:') || URL.startsWith('tel:')) ? className.replace('uk-navbar-dropdown-close', '').replace('uk-offcanvas-close', '') : className;
    const newLabel = children && children.length ? children : [icon, HideLabel ? '' : hyphenGroup ? Label.split('-').splice(1).join('-') : Label];
    const rel = NewTab ? { rel: `noopener noreferrer`} : {};
    return (<a {...link} {...scroll} {...rel} class={`uk-position-relative ${cleanClass.replace('uk-icon-button', '')}`} aria-label={Label || Icon || Alt} target={`${NewTab ? '_blank' : ''}`}>{newLabel}</a>);

};